<template>
    <div>
        <!-- Button -->
        <div v-if="urlImg" class="border rounded-xl mb-3" :id="'images-container-' + paperId">
            <img :src="urlImg" class="w-full" alt="" @click="toggleModal(true)">
        </div>

        <button class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center" :class="btnClass" type="button" @click="toggleModal(true)">
            {{buttonLabel}}
        </button>

        <!-- Main modal -->
        <div :id="'modal-draw-' + paperId" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-50 justify-center items-center h-modal md:h-full md:inset-0">
            <div class="relative px-4 w-full max-w-2xl h-full md:h-auto">
                <!-- Modal content -->
                <div class="relative bg-white rounded-lg shadow">
                    <!-- Modal body -->
                    <div class="bg-gray-50 rounded-lg border border-gray-300">
                        <svg :id="paperId" style="height: 400px"></svg>
                    </div>
                    <div class="py-2 flex justify-center">
                        <button type="button" class="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2" @click="toggleModal(false)">Fermer</button>
                        <button type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10" @click="initPaper">Recommencer</button>
                        <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ml-2" @click="render">Valider</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import ImageTool from '@/tools/ImageTool'

export default {
    props: {
        background: {
            type: String,
        },
        btnClass: {
            type: String,
            default: ""
        },
        meta: {},
        buttonLabel: {
            default: 'dessiner',
        }
    },

    data() {
        return {
            paperId: null,
            snapTool: null,
            lines: [],
            currentLine: null,
            points: [],
            intervalTimer: null,
            canDraw: false,
            urlImg: ''
        }
    },

    computed: {
        paperIdTag() {
            return '#' + this.paperId 
        }
    },

    methods: {
        async initPaper() {
            let paperEl = document.getElementById(this.paperId)
            if (paperEl) {
                paperEl.innerHTML = '';
                if (this.background) {
                    paperEl.innerHTML += this.background
                }
            }

        },

        async render() {
            let img = null
            await ImageTool.SVGToImage({
                svg: document.getElementById(this.paperId),
                mimetype: "image/png",
                quality: 1,
                height: 400
            }).then((blobImg) => {
                this.urlImg = URL.createObjectURL(blobImg);
                this.toggleModal(false)
                this.$emit('submit', {blob: blobImg, url: this.urlImg, meta: this.meta})
            }).catch(function(err){
                console.log(err);
            });

            return img
        },

        toggleModal(state) {
            if (state === true) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = 'scroll'
            }
            toggleModal('modal-draw-' + this.paperId, state)
        }
    },

    mounted() {
        this.paperId = 'snap-svg-' + (Math.random() + 1).toString(36).substring(2)

        this.$nextTick(() => {
            this.initPaper()
        })

        var positions = []
        window.addEventListener('touchstart', (eventClick) => {
            if (eventClick.touches[0].target.id == this.paperId) {
                window.addEventListener('touchmove', function(e) {
                    let position = [e.touches[0].clientX - 15, e.touches[0].clientY - 15].join(',')
                    positions.push(position)

                    // Draw line
                    if (positions.length <= 1) {
                        // Create line
                        eventClick.touches[0].target.innerHTML += '<polyline points="" stroke="#000000" style="stroke-width: 1;" fill="none"></polyline>'
                    } else {
                        // Update line
                        eventClick.touches[0].target.lastChild.setAttribute('points', positions.join(','))
                    }
                })
            }
        }, false)

        window.addEventListener('touchend', () => {
            var paperEl = document.getElementById(this.paperId)
            paperEl.innerHTML += '<polyline points="'+positions.join(',')+'" stroke="#000000" style="stroke-width: 1;" fill="none"></polyline>'
            positions = []
        }, false)
    }
}
</script>

<style lang="scss" scoped>

</style>
